import { Typography, Button } from "../../components"
import "./styles.css";

export default function Subsidieverzoek(props) {
    return (
        <div className="container">
            <iframe
                title="Ondersteuning bij subsidieverzoek NOLIA BabyFeeding"
                src="https://app.enormail.eu/subscribe/179abc35ceb7bb4e4f0dd10ac0d5e7db"
                style={{
                width: "100%",
                height: "100vh",
                border: "none"
                }}
                allow="fullscreen; payment"
            ></iframe>
        </div>
    )
}